import color from 'color';

const decorateColors = colors => Object.keys(colors).reduce((acc, key) => {
  const c = color(colors[key]);
  return ({
    ...acc,
    [key]: colors[key],
    [`${key}Color`]: [
      'negate', // rgb(0, 100, 255) -> rgb(255, 155, 0)

      'lighten', // hsl(100, 50%, 50%) -> hsl(100, 50%, 75%)
      'darken', // hsl(100, 50%, 50%) -> hsl(100, 50%, 25%)

      'saturate', // hsl(100, 50%, 50%) -> hsl(100, 75%, 50%)
      'desaturate', // hsl(100, 50%, 50%) -> hsl(100, 25%, 50%)
      'grayscale', // #5CBF54 -> #969696

      'whiten', // hwb(100, 50%, 50%) -> hwb(100, 75%, 50%)
      'blacken', // hwb(100, 50%, 50%) -> hwb(100, 50%, 75%)

      'fade', // rgba(10, 10, 10, 0.8) -> rgba(10, 10, 10, 0.4)
      'opaquer', // rgba(10, 10, 10, 0.8) -> rgba(10, 10, 10, 1.0)

      'rotate', // hsl(60, 20%, 20%) -> hsl(330, 20%, 20%)
    ].reduce((a, k) => ({ ...a, [k]: p => c[k](p).toString() }), {}),
  });
}, {});

const colors = {
  accent: '#ff9933',
  action: '#136dc9',
  create: '#0ac168',
  destructive: '#f00',
  modal: 'rgba(232, 231, 226, .75)',

  warning: '#ff0',

  link: '#075d92',
  active: '#097cc3',

  profile: '#ecf4f9',

  black: '#000',
  gray1: '#333',
  gray2: '#444',
  gray3: '#555',
  gray4: '#666',
  gray6: '#888',
  gray7: '#999',
  gray8: '#aaa',
  gray15: '#ccc',
  gray16: '#ddd',
  gray17: '#eee',
  gray18: '#f3f3f3',
  gray19: '#f7f7f7',
  gray20: '#fafafa',
  white: '#fff',

  satinblack: '#171a1c',
};

const theme = {
  unit: 8,
  mobile: 420,
  desktop: 1024,
  colors: decorateColors(colors),
};

export default theme;



// WEBPACK FOOTER //
// ./src/components/theme.js